import { WizComponentManager, ComponentInitProperties } from './../../services/core/component/wiz-component.manager';
import { WizCommand } from './../../services/core/command/wiz-command';
import { WizGroupCommand } from './../../services/core/command/wiz-group-command';
import { IWizView } from '../../interfaces/iwiz-view';
import { WizNavigationManager } from '../../services/core/navigation/wiz-navigation.manager';
import { WizActionObj } from '../../obj/navigation/wiz-action.obj';
import { OnInit, OnDestroy, ComponentRef, ViewContainerRef, AfterViewInit, Directive, ElementRef } from '@angular/core';
import { WizRoot } from './wiz-root';
import { WIZ_EVENT_TYPE, WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizEventManager } from '../../events/wiz-event.manager';
import { WizEvent } from '../../events/wiz-event';

// classe de base pour les vues
@Directive()
export class WizBaseView implements IWizView, OnInit, OnDestroy, AfterViewInit {


  // clé technique
  public code = '';
  // libellé (non traduit)
  public title = '';

  // UUID alimenté sur construction
  public uuid: string;

  // précurseur de la méthode de validation
  // @return true si tout est correct
  public wizValidation(): boolean {

    // console.log('validation' + this.title);
    return true;
  }

  // retourne la collection de boutons "métier" principaux
  public wizMainActions(): WizActionObj[] {
    return null;
  }

  // retourne la collection de boutons pour rendre la vue dynamique
  public wizConfigurationActions(): WizActionObj[] {
    return null;
  }


  constructor(public elementRef: ElementRef) {
    this.uuid = WizMathUtils.createUUID();
    this.wizAfterConstruct();
  }

  /** flag permetant de déterminé le status de wizOnInit */
  private _onInitComplete = false;

  /**
   * _pendingCallQueue
   * permet de d'exécuter des fonctions une fois le wizOnInit finie
   * sans ce système les fonctions wizSynchronizeData et addListeners sont appélés
   * et créée des erreurs dans le cycle de vie
   */
  private _pendingCallQueue = [];

  /**
   * attention, ne PAS surcharger
   */
  ngOnInit(): void {
    const completeBeforeInit = () => {
      // enregistrement de la vue
      WizNavigationManager.registerView(this);
      // this.wizOnInit();

      // init complete
      this._onInitComplete = true;

      // excecute les functions en attente
      if (this._pendingCallQueue.length > 0 ) {
        this._pendingCallQueue.forEach((fn: () => void) => {
          fn.bind(this)();
        });

        this._pendingCallQueue = [];
      }
    };

    const beforeInit = this.wizBeforeInit();
    // if it's an array instance, then we've got only promises to execute
    if (Array.isArray(beforeInit) && beforeInit.length > 0) {
      Promise.all(beforeInit).then(() => completeBeforeInit());
    } else if (beforeInit instanceof WizGroupCommand || beforeInit instanceof WizCommand) {
      // User provided a WizGroupCommand
      beforeInit.attach((pState: string) => completeBeforeInit());
      beforeInit.execute();
    } else {
      completeBeforeInit();
    }
  }

  ngAfterViewInit(): void {
    // Si wizOnIinit est fini on execute les fonction wizSynchronizeData et  wizAddListener
    this.wizAddListener();
    if (this._onInitComplete === true) {
      setTimeout(() => {
        this.wizSynchronizeData();
        this.wizInitComponents();
      });
    } else {
      // si l'init n'est pas fini on ajoute les fonctions wizSynchronizeData et wizAddListener dans la file
      // ces fonctions seront appellés seulement une fois l'initialisation finie
      this._pendingCallQueue.push(this.wizSynchronizeData);
      this._pendingCallQueue.push(this.wizInitComponents);
    }
  }

  // attention, ne PAS surcharger
  ngOnDestroy(): void {
    // désinscription de la vue
    this.wizRemoveListener();
    this.wizOnDestroy();
    WizNavigationManager.unregisterView(this);
  }


  // déclenchée sur fin de constructeur
  wizAfterConstruct(): void {
    // déclaration de la vue cible : pour écoute & synchro des zones contextuelles
    // cycle OK. Le check n'a pas encore commencé
    if (WizRoot.root()) {
      WizEventManager.dispatchEvent(WizRoot.root(),
      new WizEvent(WIZ_EVENT_TYPE.NAVIGATE_SET_VIEW, null, this));
    }
    // console.log('wizAfterConstruct:' + this.title);
  }

  /**
   * Method to help you do stuff before the view gets initialized.
   * This method can be used to define an Init command for example
   */
  wizBeforeInit(): boolean | Promise<any>[] | WizGroupCommand | WizCommand<any> { return true; }

  // cycle de vie sous contrôle
  // wizOnInit(): void {}  sur création de la vue (ngOnInit)
  wizAddListener(): void {} // après init, mise en place des écouteurs
  wizSynchronizeData(): void {//console.log('wizSynchronizeData');
  } // après listener, alimentation en données

  wizInitComponents(): void { // signaler que la vue est opérationnelle, pour que les widgets puissent déclencher leurs cycles
    // console.log('wizInitComponent');
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.VIEW_UP, null, this));
  }

  wizRemoveListener(): void {} // avant destroy, suppression des écouteurs
  wizOnDestroy(): void {}// sur désallocation (ngOnDestroy)

  /**
   * Method to add a component dynamically into a container
   *
   * The reference to the added component is returned once it's added to the container.
   *
   * @param pComponentClass The component class to dynamically instanciate
   * @param pContainer The container in whiche to add the created component
   * @param pInitProperties Optional. Initialization properties to set on the newly create component
   * @returns The reference to the created component
   */
  wizAddChild(pComponentClass: any, pContainer: ViewContainerRef, pInitProperties?: ComponentInitProperties): ComponentRef<any> {
    return WizComponentManager.instance.addChildTo(pComponentClass, pContainer, pInitProperties);
  }

  /**
   * Removes an element from the given container
   *
   * This method does not trigger any errors. If no element could be removed, then nothing happens
   *
   * @param pComponentRef Reference to the component to remove
   * @param pContainer The container from which to remove the component
   * @returns True if the component was successfully removed
   */
  wizRemoveChild(pComponentRef: ComponentRef<any>, pContainer: ViewContainerRef): boolean {
    return WizComponentManager.instance.removeChildFrom(pComponentRef, pContainer);
  }
}
